const LightBox = () => {
    const lightBox = document.getElementById('js-lightbox');
    const closeBtn = document.getElementById('js-btn-close-lightbox');

    const lightBoxBtns =
        document.querySelectorAll<HTMLElement>('.js-lightbox-img');

    if (!lightBox) {
        console.warn(`Lightbox not found.`);
        return;
    }

    if (!lightBoxBtns) {
        console.warn('Lightbox Images not found.');
        return;
    }

    const lightBoxImg = lightBox.querySelector<HTMLImageElement>('img');

    if (!lightBoxImg) {
        console.warn('Lightbox Primary Image not found.');
        return;
    }

    const initLightbox = () => {
        lightBoxBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const _src = btn.dataset.src;
                if (_src) {
                    lightBoxImg.src = _src;
                    lightBox.classList.add('active');
                }                
            });
        });
    };

    if (closeBtn) {
        // Close the lightbox when clicking the close button
        closeBtn.addEventListener('click', () => {
            lightBox.classList.remove('active');
        });
    }

    initLightbox();
};

export default LightBox;
